module.exports = __webpack_public_path__ + "assets/img/02_tmall_100x100.814db7a7.png";